import { useRef } from 'react';

import { ImageOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';
import DragDrop from '@/features/media/plugins/DragDrop';

import SingleAvatar from '../AvatarSelector/SingleAvatar';
import { avatarImage } from '../AvatarSelector/style';
import { UploadImageProps } from './types';

const UploadImage: React.FC<UploadImageProps> = (props) => {
  const { selectAvatar, selectedAvatar, uppy, files } = props;

  const fileInput = useRef<DragDrop>(null);
  const showFileSelector = () => fileInput.current?.showUploadDialog();

  return (
    <>
      <DragDrop ref={fileInput} DragView={<></>} accept="image/*" uppy={uppy}>
        <Box
          className={cn(
            'h-full cursor-pointer rounded-full border border-dashed border-border-dark bg-bg-secondary',
            avatarImage,
          )}
          onClick={showFileSelector}>
          <Stack
            alignItems="center"
            className="h-full w-full"
            direction="col"
            justifyContent="center">
            <ImageOutline className="h-32 w-32" fillColorToken="icon-secondary" />
          </Stack>
        </Box>
      </DragDrop>
      {Object.values(files).map((file) => (
        <SingleAvatar
          key={file.url}
          selectAvatar={selectAvatar}
          selectedAvatar={selectedAvatar}
          url={file.url || ''}
        />
      ))}
    </>
  );
};

export default UploadImage;
